import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExportDialogData, ReportExportRequest } from '../internal-export.model';

@Component({
    selector: 'hq-export-dialog',
    templateUrl: './export-dialog.component.html',
    styleUrls: ['./export-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExportDialogComponent implements OnInit {
    title: string;
    form: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<ExportDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: ExportDialogData,
        private formBuilder: FormBuilder
    ) {
        this.title = this.data.title;
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            emailAddress: [this.data.emailAddress, [Validators.required, Validators.email]]
        });
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onSubmit(): void {
        if (this.form.invalid) {
            return;
        }

        const exportRequest: ReportExportRequest = {
            reportName: this.data.exportType,
            emailAddress: this.form.value.emailAddress,
            brokerId: this.data.brokerId,
            legacyId: this.data.legacyId,
            chainId: this.data.chainId,
            chainStoreId: this.data.chainStoreId,
            search: this.data.search
        };
        this.dialogRef.close(exportRequest);
    }
}
